module.exports = {
    drsf_force: "Erzwingen Sie die Verwendung dieses DRSF",
    lora_boot_msg: "Gerät sendet beim Booten eine Nachricht auf LoRa",
    lora_on_wifi_connect: "Das Gerät sendet Nachrichten auf LoRa, wenn eine Verbindung zu WiFi besteht",
    cumulative_current: "Kumulativer Strom",
    cumulative_active_power: "Kumulative Wirkleistung",
    cumulative_reactive_power: "Kumulative Blindleistung",
    cumulative_apparent_power: "Kumulative Scheinleistung",
    cumulative_energy_import: "Kumulativer Energieimport",
    cumulative_energy_export: "Kumulativer Energieexport",
    average_of_average_voltages: "Durchschnitt der durchschnittlichen Spannungen",
    cumulative_average_current: "Kumulativer Durchschnittsstrom",
    cumulative_average_active_power: "Kumulative durchschnittliche Wirkleistung",
    reactive_energy: "Blindleistung",
    quadrant: "Quadrant",
    overall_reactive_energy_import: "Gesamtimport von Blindleistung",
    overall_reactive_energy_export: "Gesamtexport von Blindleistung",
    time_scaler: "Zeitstrahl",
    power_scaler: "Leistungsskala",
    lora_rssi: "LoRa empfangene Signalstärkeanzeige",
    wifi_rssi: "WiFi empfangene Signalstärkeanzeige",
    applications: "Anwendungen",
    devices: "Geräte",
    settings: "die Einstellungen",
    power_on: "Ein",
    power_off: "Ausschalten",
    visible: "Sichtbar",
    invisible: "Unsichtbar",
    cumulative: "Kumulativ"
}